/* nm-header.js — Custom element script for No Maps Header Navigation */

class NmHeader extends HTMLElement {
  connectedCallback() {
    this.toggleBtn = this.querySelector('.nm-header__menu-toggle');
    this.drawer = this.querySelector('.nm-header__mobile-drawer');
    this.overlay = this.querySelector('.nm-header__mobile-overlay');
    this.links = this.querySelectorAll('.nm-header__mobile-link');
    this.content = this.querySelector('.nm-header__mobile-content');

    if (!this.toggleBtn || !this.drawer) return;

    this.toggleBtn.addEventListener('click', () => this.toggleMenu());
    this.overlay?.addEventListener('click', () => this.closeMenu());

    // Listen for Escape key to close the drawer
    this.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.drawer.getAttribute('aria-hidden') === 'false') {
        this.closeMenu();
      }
    });

    // Close on link click (useful for hash links if they exist)
    this.links.forEach(link => {
      link.addEventListener('click', () => this.closeMenu());
    });
  }

  toggleMenu() {
    const isOpen = this.toggleBtn.getAttribute('aria-expanded') === 'true';
    if (isOpen) {
      this.closeMenu();
    } else {
      this.openMenu();
    }
  }

  openMenu() {
    this.toggleBtn.setAttribute('aria-expanded', 'true');
    this.drawer.setAttribute('aria-hidden', 'false');
    this.toggleBtn.classList.add('nm-header__menu-toggle--active');
    this.drawer.classList.add('nm-header__mobile-drawer--open');
    
    // HTML scroll lock
    document.documentElement.style.overflow = 'hidden';
  }

  closeMenu() {
    this.toggleBtn.setAttribute('aria-expanded', 'false');
    this.drawer.setAttribute('aria-hidden', 'true');
    this.toggleBtn.classList.remove('nm-header__menu-toggle--active');
    this.drawer.classList.remove('nm-header__mobile-drawer--open');
    
    // HTML scroll unlock
    document.documentElement.style.overflow = '';
  }
}

customElements.define('nm-header', NmHeader);
